import { SxyTableController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Renders a read-only table based on a schema and ata.
 * @example <sxy-table></sxy-table>
 */
export class SxyTable extends ComponentBase {
  /** Component bindings. */
  public bindings = {
    /** The schema definition that defines the structure of the grid. */
    schemaDef: "<",

    /** URL of the schema document that contains the schemaDef. If set with schema in init, loads the document.*/
    doc: "@",

    /** Key of schemaDef in doc. If set with doc in init, will load the schema document from server and set the schemaDef.*/
    schema: "@",

    /** Data that is rendered / edited in the grid. This is either an array or an object that implements getTabulatorConfig() method for ajax data.*/
    data: "<",

    /**
     * List of columns to include in the grid.
     * This may be an array or comma separated string of field names (or a property tree, e.g. "owner.avatar.displayName").
     * Alternatively, the entries in the array may be be full Tabulator column definitions, where `field` propererty defines the
     * data item and fetches the default properties from the schema.
     */
    include: "<",

    /**
     * List of columns to exclude from the grid.
     * This property is currenlty used only if include property is undefined, i.e. in default
     * rendering, which will render the first-level properties. As such, exclude does not really support property paths.
     */
    exclude: "<",

    /** Additional configuration for the table in init. */
    options: "<",

    /** After init, exposes the Tabulator for calling methods. */
    tabulator: "<",

    /**
     * Gets the state of filters or sets the initial state of filters.
     * By default, the filters are not shown before showFilters() function is called.
     * If the property / attribute is set to true before initial render, the filters are shown.
     * Use showFilters() function to show or hide the filters after initial render.
     */
    filters: "<"
  };

  /** Uses the SxyTableController */
  public controller = SxyTableController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/sxy-table/SxyTable.html";
}
